import { Injectable, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { Store } from '@ngrx/store';
import { HistoryFacade } from '../history-entries';
import { WorkspaceFacade } from '../workspace';
import { ChatMessage, DefineDefinition, initialDefineDefinition } from './define.models';
import { DefineActions } from './define.actions';
import {
  selectDefineChatMessages,
  selectDefineDefinition,
  selectDefineError,
  selectDefineIsReady,
  selectDefineLoading,
  selectDefineRepoContext,
} from './define.selectors';

@Injectable({ providedIn: 'root' })
export class DefineFacade {
  private store = inject(Store);
  private workspace = inject(WorkspaceFacade);
  private history = inject(HistoryFacade);

  readonly definition = toSignal(this.store.select(selectDefineDefinition), { initialValue: initialDefineDefinition });
  readonly chatMessages = toSignal(this.store.select(selectDefineChatMessages), { initialValue: [] as ChatMessage[] });
  readonly repoContext = toSignal(this.store.select(selectDefineRepoContext), { initialValue: null });
  readonly loading = toSignal(this.store.select(selectDefineLoading), { initialValue: false });
  readonly error = toSignal(this.store.select(selectDefineError), { initialValue: null });
  readonly isReady = toSignal(this.store.select(selectDefineIsReady), { initialValue: false });
  readonly activeProjectId = this.workspace.activeProjectId;

  load(): void {
    this.store.dispatch(DefineActions.load());
  }
  saveDefinition(definition: DefineDefinition): void {
    this.store.dispatch(DefineActions.saveDefinition({ definition }));
  }
  setChatMessages(messages: ChatMessage[]): void {
    this.store.dispatch(DefineActions.setChatMessages({ messages }));
  }
  async logChatEvent(text: string, kind: 'user' | 'assistant' | 'info' | 'update' | 'error' = 'info'): Promise<void> {
    const projectId = this.activeProjectId();
    if (!projectId) return;
    await this.history.add(projectId, 'define.chat', text, kind as any);
  }
}
